<button
  class="btn position-relative"
  (click)="onClick($event)"
  [routerLink]="routerLink"
  [ngClass]="classes"
  [disabled]="disabled || this.isLoading"
  [type]="type"
  [class.button-text-variant]="variant === 'text'"
>
  @if (isLoading) {
    <span class="position-absolute loadingSpinner">
      <span class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
      </span>
    </span>
  }
  @if (icon(); as icon) {
    <chitin-icon
      [icon]="icon"
      class="btn-icon"
      [size]="sizeSanitized()"
      [ngClass]="{
        'float-end ms-2': iconPosition === 'right' && size() !== 'xs',
        'float-end ms-1': iconPosition === 'right' && size() === 'xs',
        'float-start me-2': iconPosition === 'left' && size() !== 'xs',
        'float-start me-1': iconPosition === 'left' && size() === 'xs',
        'opacity-0': this.isLoading,
      }"
    />
  }
  @if (label) {
    <span [ngClass]="{ 'opacity-0': this.isLoading }" class="btn-label"> {{ label }} </span>
  }
  <ng-content [ngClass]="{ 'opacity-0': this.isLoading }" />
</button>
